/**
 * Een foutscherm in ontwerp v4: het zand, het merk als de weg terug,
 * de fout als zin, één regel uitleg en één volle knop naar waar je verder
 * kunt (ingelogd Vandaag, anders de voorpagina). De foutcode staat klein
 * onderaan, voor wie hem wil doorgeven; nooit de ruwe fouttekst.
 */
import { Link } from 'react-router'
import { useT } from '#app/utils/i18n.tsx'
import { useOptionalUser } from '#app/utils/user.ts'
import { HeuteMerk } from './merk.tsx'

export function FoutScherm({
	titel,
	tekst,
	code,
	knop,
}: {
	titel: string
	tekst?: string
	/** De HTTP-status, klein onderaan (niet bij 404: de zin zegt het al). */
	code?: number
	/** Een eigen weg verder; anders Vandaag of de voorpagina. */
	knop?: { naar: string; label: string }
}) {
	const t = useT()
	const ingelogd = Boolean(useOptionalUser())
	const verder = knop ?? {
		naar: ingelogd ? '/vandaag' : '/',
		label: ingelogd ? t('boundary.naar_vandaag') : t('boundary.naar_begin'),
	}
	return (
		<main className="auth-scherm" data-testid="fout-scherm">
			<div className="auth-kolom pad">
				<header className="auth-kop">
					<HeuteMerk naar={ingelogd ? '/vandaag' : '/'} />
				</header>
				<div className="auth-inhoud">
					<h1 className="zin-kop">{titel}</h1>
					{tekst ? <p className="zin-sub">{tekst}</p> : null}
					<Link
						to={verder.naar}
						className="btn btn-primary"
						data-testid="fout-verder"
						style={{ width: '100%', minHeight: 'var(--size-knop)', marginTop: 28 }}
					>
						{verder.label}
					</Link>
					{code && code !== 404 ? (
						<p className="auth-voet" style={{ fontSize: 13 }}>
							{t('boundary.foutcode', { status: code })}
						</p>
					) : null}
				</div>
			</div>
		</main>
	)
}
